import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import {connect} from 'react-redux';
import TopupForm from '../PageUserDashboard/TopupForm';
import { doTopUp } from '../../actions/topUpAction';

class TopUpBalance extends Component{
  constructor(props) {
    super(props);
      this.state = {
        modalTopup: false
      }
  }

  toggleTopup = () => {
    this.setState({
      modalTopup: !this.state.modalTopup,
    })
  }

  _handleSubmitTopup = (payloads) => {
    this.props.topup(payloads)
  }

  render(){
    const { topUp } = this.props.dataTopUp;
    return(
      <div>
        <TopupForm
          isOpen={this.state.modalTopup}
          onToggle={this.toggleTopup}
          onSubmit={this._handleSubmitTopup}
          dataTopUp={topUp}
        />
        <Paragraph onClick={() => this.toggleTopup()}>TOP UP BALANCE</Paragraph>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dataTopUp: state.dataTopUp
  }
}

const mapDistpatchToProps = (dispatch) => {
  return {
    topup : (payload) => dispatch(doTopUp(payload)),
  }
}

export default connect(mapStateToProps, mapDistpatchToProps)(TopUpBalance)

const Paragraph = styled.p`
  text-decoration: underline;
  color: #4990e2;
  cursor: pointer;
`;